import React from 'react';
import { urlWebsite } from '../../../../../../../config';
import { ParagraphStyle } from '../../ContentItem/styles';

import { useModal } from 'src/hooks/Modal';

interface IProps {
    list: Record<string, any>;
    computer: Record<string, any>;
    mobile: Record<string, any>;
}


const DataLine = ({ item, computer, mobile }: any) => {

    const { addModal } = useModal();

    const openPopup = (content) => {
        console.log(content)
        addModal({
            title: '', content: <div className='row-to-column  gap-sm' style={{ alignItems: 'flex-start' }}>
                <div>
                    <img src={`${urlWebsite}/${item?.image}`} style={{ width: '150px', borderRadius: item?.['border-radius'] || '0px' }} />

                </div>
                <div className='column-start'>
                    {content?.title_popup ? <h2 style={{ width: '100%', textAlign: 'left', paddingBottom: '15px', fontSize: '18px', lineHeight: '24px', color: '#333' }}>{content?.title_popup}</h2> : <></>}
                    {content?.description_popup ? <p dangerouslySetInnerHTML={{ __html: content?.description_popup }} style={{ width: '100%', textAlign: 'left', fontSize: '16px', lineHeight: '24px', color: '#333' }} /> : <></>}
                </div>
            </div>, key: 'popupmodal', theme: 'whiteModalMedium'
        })

    }

    return <div onClick={() => item?.have_popup === 'yes' ? openPopup(item) : false} className='row-start' style={{ gap: '10px', width: 'auto' }} >
        <img src={`${urlWebsite}/${item?.image}`} style={{ width: item?.width || '20px', borderRadius: item?.['border-radius'] || '0px', border: item?.border || '0px' }} />
        <ParagraphStyle computer={computer} mobile={mobile} dangerouslySetInnerHTML={{ __html: item?.title }} />
    </div>

}

const DataList: React.FC<IProps> = ({ list, computer, mobile }) => {

    return (<>{
        list?.map(item => <DataLine item={item} computer={computer} mobile={mobile} />)
    }

    </>);
};
export default DataList;
